/**
 * Converts a JavaScript value to a JavaScript Object Notation (JSON) string, without failing on circular
 * references.
 *
 * @param obj The base object to stringify.
 * @param replacer A replacement function to apply on every object key value pairs (defaults to returning the value)
 * @param space Adds indentation, white space, and line break characters to the return-value JSON text to make it easier
 *              to read.
 * @returns The stringified object.
 */
export function json(obj, { replacer = (_, v) => v, space } = {}) {
    const cache = [];
    return JSON.stringify(obj, (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (cache.includes(value)) {
                return '[Item Removed - Duplicated reference]';
            }
            cache.push(value);
        }
        return replacer(key, value);
    }, space);
}
//# sourceMappingURL=stringify.js.map